module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Schneisingen-f92e6c9363ab2088256ee8d820b4022f.svg";